import { routePlanApis } from '@apis/dashboard/routePlanApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useRoutePlan = createUseQuery(
  (id: number) => ['/dashboard/route-plan/', id],
  (id) => () =>
    routePlanApis.get('/dashboard/route-plan/{id}/', { path: { id } }).then((r) => r[200]!),
);
